<template>
  <main class="bg-white overflow-x-clip">
    <section id="mainslider" class="">
      <div class="relative w-full h-full">
        <DelayHydration>
          <FullScreenHero critical :data-slider="heroSectionData" @onLoaded="handleSliderLoad"/>
        </DelayHydration>
      </div>
    </section>
    <DelayHydration>
      <div :class="!showSect2 ? 'min-h-screen':''">
        <section v-if="ready && showSect2" id="sect2" class="bg-ip-color-8 relative">
          <div class="container-2 mx-auto relative">
            <div class="py-14 lg:py-28 relative z-1">
              <div class="lg:flex gap-[4vw] items-center">
                <div class="relative h-full w-full lg:w-1/2 flex items-center">
                  <div class="space-y-10 lg:space-y-8">
                    <h1 class="px-4 xl:px-0 figtree text-2xl leading-8 md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2vw] lg:leading-[2.6vw] text-ip-color-3"
                      data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200"
                    >
                      <span class="figtree font-bold">ImpacThink</span> is poised to become a <span class="figtree font-semibold">leading creative-based sustainability communication consulting firm.</span>
                    </h1>
                    <div class="aspect-[400/300] md:aspect-[600/300] relative pl-4 lg:hidden" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                      <figure class="w-full h-full relative rounded-l-3xl overflow-clip">
                        <div class="bg-gray-200 animation-pulse w-full h-full absolute top-0 right-0"></div>
                        <ClientOnly>
                          <img alt="impacthink" src="/images/home/sect-2.webp" loading="lazy" format="webp" quality="80" data-aos="fade" data-aos-easing="ease-out-sine" data-aos-delay="500" class="object-cover w-full h-full absolute z-1">
                        </ClientOnly>
                      </figure>
                    </div>
                    <p class="px-4 xl:px-0 figtree font-medium leading-6 text-base md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.8vw]" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="150">
                      As pioneers in creative-based sustainability communication, we leverage a holistic approach, innovative solutions, and industry-leading expertise to empower you to achieve enduring positive impact through comprehensive sustainability communication services.
                    </p>
                    <div class="px-4 xl:px-0 space-y-3" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                      <div class="figtree text-base leading-[32px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.2vw] lg:leading-[1.8vw] font-bold">Unleashing your potential with our unique advantages:</div>
                      <div v-for="(item, i) in checklistSection2" :key="i" class="flex gap-2 items-center text-ip-color-7">
                        <Icon name="ic:round-check" class="w-5 h-5"/>
                        <div class="figtree text-sm leading-[32px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.2vw] lg:leading-[1.8vw] font-medium">{{ item.text }}</div>
                      </div>
                    </div>
                    <div class="px-4 xl:px-0 flex justify-center lg:justify-start w-fit " data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                      <NuxtLink
                        class="figtree group rounded-3xl h-full py-2 px-3 lg:py-3 lg:px-6 w-fit hover:bg-ip-color-2 bg-ip-color-12 hover:shadow-lg font-semibold text-base md:text-[1.4vw] lg:text-[1.1vw] hover:text-ip-color-3 text-white flex items-center gap-1 transition-colors duration-300"
                        :to="({ name: 'about-us' })">
                          About Us
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300">
                            <path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
                          </svg>
                      </NuxtLink>
                    </div>
                  </div>
                </div>
                <div class="hidden lg:block lg:w-1/2 relative aspect-[700/600] overflow-clip rounded-l-3xl"></div>
              </div>
            </div>
            <figure class="opacity-5 absolute bottom-10 left-10">
              <VectorSingleArrow color="ip-color-3" class="max-w-52"/>
            </figure>
          </div>
          <div class="hidden lg:flex absolute top-1/2 -translate-y-1/2 left-0 w-full h-[80%]  items-center">
              <div class="w-1/2 h-full relative"></div>
              <div class="w-1/2 h-full relative rounded-l-3xl overflow-clip" data-aos="fade-left" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                <figure class="w-full h-full">
                  <div class="bg-gray-200 animation-pulse w-full h-full absolute top-0 right-0"></div>
                  <ClientOnly>
                    <img alt="impacthink" src="/images/home/sect-2.webp" loading="lazy" format="webp" quality="80" data-aos="fade" data-aos-easing="ease-out-sine" data-aos-delay="500" class="object-cover w-full h-full absolute z-1">
                  </ClientOnly>
                </figure>
              </div>
            </div>
        </section>
      </div>

      <section v-if="ready" class="obs-client py-14 lg:py-28">
        <div class="container-1 space-y-16">
          <div class="lg:space-y-24">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              <div class="lg:max-w-[41vw] space-y-1 lg:space-y-3" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                <div class="figtree font-semibold text-ip-color-3 text-xs lg:text-[.8vw] uppercase bg-ip-color-10 rounded-md w-fit p-[.38rem]">This is what we offer</div>
                <div class="figtree w-full font-semibold text-ip-color-3 text-2xl leading-[48px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] ">ARC Framework</div>
                <div class="figtree font-medium w-full text-base leading-[24px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.8vw]">Our framework is designed to enhance sustainability across three core areas: Act, Report, and Communicate. This framework helps you implement effective sustainability actions, produce detailed reports, and engage stakeholders through clear communication, driving continuous improvement and <br class="md:hidden">greater impact.</div>
              </div>
              <div class="py-14 lg:py-0 flex justify-center lg:static" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                <!-- <video Loop autoPlay playsInline muted preload="metadata" class="w-[100vw] h-auto max-w-lg xl:max-w-[35vw] user-select-none touch-none pointer-events-none">
                  <source type="video/webm" src="/videos/arc.webm" />
                  <source type="video/mp4" src="/videos/arc.mp4" />
                </video> -->
                <dotlottie-player src="https://lottie.host/108bf551-3e7f-44c4-a8d2-e2a62ac59dee/RrYOsNZclW.lottie" background="transparent" speed="1" class="arc-lottie w-[100vw] h-auto max-w-lg xl:max-w-[35vw]" Loop autoPlay></dotlottie-player>
              </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-14 lg:gap-20">
              <div v-for="(item, i) in arcDetail" :key="i" class="space-y-3" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                <div class="flex items-center gap-4">
                  <figure class="max-w-8">
                    <VectorSingleArrow color="ip-color-10" />
                  </figure>
                  <div class="figtree text-lg md:text-[2vw] lg:text-[1.4vw] font-semibold uppercase text-ip-color-3">{{ item.title }}</div>
                </div>
                <div class="figtree font-medium text-base md:text-[1.4vw] lg:text-[1vw] md:leading-[2vw] lg:leading-[1.5vw]" v-html="item.desc"></div>
              </div>
            </div>
          </div>
          <div class="hidden md:block border-t border-[#CCCCCC] w-full"></div>
          <div class="w-full" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
            <ClientOnly>
              <StackedStickyCard />
            </ClientOnly>
          </div>
        </div>
      </section>

      <div v-if="ready && showSliderClient">
        <SliderClient v-if="isLargeScreen" :items="portfolioData" @scroll-to="handleScrollTo" :scrollPos="scrollPos" :scroll-direction="scrollDirection" :ready="ready" />
        <SliderClientMobile v-else :items="portfolioData" />
      </div>

      <section v-if="ready" class="py-14 md:py-28 bg-ip-color-11 relative">
        <div class="container-1 space-y-12 md:space-y-16">
          <TeamExperts/>
        </div>
      </section>

      <section v-if="ready" class="bg-ip-color-3 py-12 md:py-[6.944vw] big-screen:py-[5.208vw] relative z-10">
        <div class="container-1 md:flex justify-start items-start gap-6 md:gap-[6.944vw] big-screen:gap-[7.813vw]">
          <div class="relative md:w-6/12 space-y-3 md:space-y-[1.667vw] big-screen:space-y-[1.25vw]">
            <div class="text-ip-color-3 space-y-2" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
              <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-ip-color-10 rounded-md w-fit p-[.38rem]">Get in touch</div>
              <div class=" text-2xl md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[1.5] font-semibold figtree text-white md:whitespace-pre-line">
                {{ 'Get Our Exclusive Training Modules & \nCredentials' }}
              </div>
            </div>
            <div class="text-white text-base md:text-[1.25vw] md:leading-normal md:whitespace-pre-line" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="250">
              {{ `Fill out the form with your Name, Company, and Email to receive \nthe ${new Date().getFullYear()} Training Modules and Credentials directly in your inbox` }}
            </div>
            <div class="absolute right-0 top-0 md:static">
              <svg class="size-20 md:mt-[6.944vw] big-screen:mt-[5.208vw] md:w-[6vw]" viewBox="0 0 102 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 49.035V96.3078H50.697V1.15625H101V49.035H1Z" stroke="#8AB9B7" stroke-opacity="0.5" stroke-width="1.21212"/>
              </svg>
            </div>
          </div>
          <div class="mt-6 md:mt-0 md:w-6/12" data-aos="fade-right" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
            <FormSubmission />
          </div>
        </div>
      </section>
    </DelayHydration>

  </main>

</template>

<script setup>
import { Interactions } from '../interactions';
const route = useRoute();
const router = useRouter();
const isMediumScreen = useMediaQuery('(min-width: 768px)');
const isLargeScreen = useMediaQuery('(min-width: 1024px)');
const ready = ref(false);
 
definePageMeta({
  layout: 'home-layout',
});

const { $refreshAos } = useNuxtApp();
const emits = defineEmits(['onLoaded']);
const dayjs = useDayjs();
const interactionsVar = new Interactions();
useSeoMeta({
  ogUrl: 'https://impacthink.id',
  title: 'Home - ImpacThink',
  ogTitle: 'Home - ImpacThink',
  twitterTitle: 'Home - ImpacThink',
  description: 'Welcome to ImpacThink',
  ogDescription: 'Welcome to ImpacThink',
  twitterDescription: 'Welcome to ImpacThink',
  ogType: 'website',
  ogImage: '/seo-image.webp',
  twitterImage: '/seo-image.webp',
  twitterCard: 'summary',
});

const heroSectionData = ref([]);
const { data } = await useAsyncData('heroSectionDoc', () => $fetch('/api/cms/home', {
  method: 'POST',
  body: { action: 'front-hero', status: 'active' }
}))
heroSectionData.value = data.value.result.sliders;

const portfolioData = ref([]);

const checklistSection2 = ref([
  {
    text: 'Tech-enhanced Innovative Solutions',
  },
  {
    text: 'Trusted Professionals',
  },
  {
    text: 'Boundless Connections',
  },
]);

const arcDetail = ref([
  {
    title: 'ACT',
    desc: 'We enhance your ability to launch impactful <br class="hidden lg:inline">sustainability initiatives and build strategic <br class="hidden lg:inline">partnerships, driving substantial environmental <br class="hidden lg:inline">and social changes. This service empowers you <br class="hidden lg:inline">to act decisively and effect significant <br class="hidden lg:inline">transformation within your organization and <br class="hidden lg:inline">the broader community.',
  },

  {
    title: 'REPORT',
    desc: 'Our expertise supports you in crafting detailed <br class="hidden lg:inline">sustainability reports that showcase your <br class="hidden lg:inline">commitment and narrate your sustainability <br class="hidden lg:inline">journey creatively. By integrating stories, <br class="hidden lg:inline">visuals, and videos, we ensure your <br class="hidden lg:inline">achievements are comprehensible and <br class="hidden lg:inline">impactful for<br class="lg:hidden">all stakeholders.',
  },

  {
    title: 'COMMUNICATE',
    desc: 'Our comprehensive stakeholder analysis and <br class="hidden lg:inline">ESG strategy development ensure your <br class="hidden lg:inline">sustainability efforts resonate with each <br class="hidden lg:inline">audience segment. We focus on strategic <br class="hidden lg:inline">engagement and clear communications to <br class="hidden lg:inline">ensure your sustainability vision is compelling <br class="hidden lg:inline">and leaves a lasting impact.',
  },
]);

const handleSliderLoad = () => {
  ready.value = true;
  nextTick(() => {
    startClientObserver();
  });
  emits('onLoaded');
};

const scrollPos = ref(0);
const scrollDirection = ref(1);
// const lenisProgress = ref();
const startLenis = () => {
  if (interactionsVar) {
    interactionsVar.createSmoothScroll();
    interactionsVar.startLenis();
    interactionsVar.lenis.on('scroll', (e) => {
      scrollPos.value = e.scroll;
      scrollDirection.value = e.direction;
      // lenisProgress.value.style.width = (e.progress * 100) + '%';
      if (scrollDirection.value < 0) {
        navbarStore.showNavbarValue();
      } else {
        navbarStore.hideNavbarValue();
      }
    });
  }
};

const destroyLenis = () => {
  if (interactionsVar) interactionsVar.destroyLenis();
};

const handleScrollTo = (el) => {
  interactionsVar.lenis.scrollTo(el);
};

onMounted(() => {
  navbarStore.closeTeamDetail();
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);

  nextTick(() => {
    $refreshAos();
    startLenis();
    // handleSliderLoad();
  });
});

onBeforeUnmount(() => {
  destroyLenis();
});

const navbarStore = useNavbarStore();
const { showSideBar, showContact, showTeamDetail } = storeToRefs(navbarStore);
watch(() => showSideBar.value,
  (val) => {
    if (val) {
      interactionsVar.lenis.stop();
    } else {
      interactionsVar.lenis.start();
    }
  },
);
watch(() => showContact.value,
  (val) => {
    if (val) {
      interactionsVar.lenis.stop();
    } else {
      interactionsVar.lenis.start();
    }
  },
);
watch(() => showTeamDetail.value,
  (val) => {
    if (val) {
      interactionsVar.lenis.stop();
    } else {
      interactionsVar.lenis.start();
    }
  },
);
const showSliderClient = ref(false);
const showSect2 = ref(false);
const startClientObserver = () => {
  const sect2callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.intersectionRatio < 0.5) {
          showSect2.value = true;
        }
      }
    });
  };
  const options2 = {
    root: null,
    rootMargin: '0px',
    threshold: [0.0, 0.5],
  };
  const sect2observer = new IntersectionObserver(sect2callback, options2);
  sect2observer.observe(document.querySelector('#mainslider'));
};

watch(() => showSect2.value, async (val) => {
  if (val === true) {
    const { data: portfolioDoc } = await useAsyncData('portfolioDoc', () => $fetch('/api/cms/portfolio', {
      method: 'POST',
      body: { action: 'featured', status: 'active' }
    }))
    portfolioData.value = portfolioDoc.value && portfolioDoc.value.result ? portfolioDoc.value.result.portfolios : [];
    if (process.client && portfolioData.value.length > 0) {
      const injectSeeMore = {
        ...portfolioData.value[portfolioData.value.length - 1],
        type: 'cta',
        target: { name: 'our-services' },
      };
      portfolioData.value.push(injectSeeMore);
      showSliderClient.value = true;
    }
  }
});

</script>

<style lang="scss" scoped>

</style>
